import serviceRequest from "utils/request";

const baseUrl = "/api/information";

/**
 * Get all undertakings for an organization
 * @param {number} organizationId - Organization ID
 * @returns {Promise} - List of undertakings
 */
export const getUndertakingsByOrganization = (organizationId) => {
	return serviceRequest({
		url: `${baseUrl}/undertakings/by-organization`,
		method: "get",
		params: { organizationId },
	});
};

/**
 * Get all organizations with undertakings
 * @returns {Promise} - List of organizations
 */
export const getOrganizationsWithUndertakings = () => {
	return serviceRequest({
		url: `${baseUrl}/undertakings/organizations`,
		method: "get",
	});
};

/**
 * Create a new undertaking version
 * @param {Object} data - Undertaking data
 * @returns {Promise} - Created undertaking
 */
export const createUndertaking = (data) => {
	return serviceRequest({
		url: `${baseUrl}/undertakings`,
		method: "post",
		data,
	});
};

/**
 * Update an existing undertaking
 * @param {number} id - Undertaking ID
 * @param {Object} data - Updated data
 * @returns {Promise} - Updated undertaking
 */
export const updateUndertaking = (id, data) => {
	return serviceRequest({
		url: `${baseUrl}/undertakings/${id}`,
		method: "put",
		data,
	});
};

/**
 * Get undertaking by ID
 * @param {number} id - Undertaking ID
 * @returns {Promise} - Undertaking details
 */
export const getUndertakingById = (id) => {
	return serviceRequest({
		url: `${baseUrl}/undertakings/${id}`,
		method: "get",
	});
};
